// https://github.com/necolas/react-native-web/issues/374

import {
  TouchableOpacity,
  TouchableHighlight,
  TouchableOpacityProps,
  TouchableHighlightProps,
  TouchableWithoutFeedback,
  TouchableWithoutFeedbackProps,
} from "react-native";
import { cloneElement } from "react";

const OpacityButton = (TouchableOpacity as any).type;
const HighlightButton = (TouchableHighlight as any).type;
const WithoutFeedbackButton = (TouchableWithoutFeedback as any).type;

if (OpacityButton && typeof OpacityButton.render == "function") {
  const _render = OpacityButton.render;
  OpacityButton.render = function (props: TouchableOpacityProps, ref: any) {
    try {
      return _render(
        { ...props, style: [{ outline: "none" }, props.style] },
        ref
      );
    } catch (error) {
      console.warn("TouchableOpacity.pollyfill", error);
      return _render(props, ref);
    }
  };
}

if (HighlightButton && typeof HighlightButton.render == "function") {
  const __render = HighlightButton.render;
  HighlightButton.render = function (props: TouchableHighlightProps, ref: any) {
    try {
      return __render(
        { ...props, style: [{ outline: "none" }, props.style] },
        ref
      );
    } catch (error) {
      console.warn("TouchableHighlight.pollyfill", error);
      return __render(props, ref);
    }
  };
}

if (
  WithoutFeedbackButton &&
  typeof WithoutFeedbackButton.render == "function"
) {
  const __render = WithoutFeedbackButton.render;
  WithoutFeedbackButton.render = function (
    props: TouchableWithoutFeedbackProps,
    ref: any
  ) {
    try {
      return cloneElement(__render(props, ref), {
        ...props,
        style: [{ outline: "none" }],
      });
    } catch (error) {
      console.warn("TouchableWithoutFeedback.pollyfill", error);
      return __render(props, ref);
    }
  };
}
